import { getEnv } from '../utils/environment';
let s3Env = getEnv();
let host;
let protocol;
let apiBaseUrl;

switch (getEnv()) {
	case 'dev':
		host = 'dev.santillana.com.br';
		protocol = 'https:';
		apiBaseUrl = 'https://www.santillana.com.br/cms/index.php/wp-json';
		break;
	case 'hml':
		host = 'homol.santillana.com.br';
		protocol = 'https:';
		apiBaseUrl = 'https://www.santillana.com.br/cms/index.php/wp-json';
		break;
	case 'prd':
		host = 'www.santillana.com.br';
		protocol = 'https:';
		// Em produção a API fica no mesmo host do portal: evita CORS e redirects.
		apiBaseUrl = '/cms/index.php/wp-json';
		break;
	default:
		s3Env = 'dev';
		host = 'dev.santillana.com.br';
		protocol = 'https:';
		apiBaseUrl = 'https://www.santillana.com.br/cms/index.php/wp-json';
		break;
}

// Permite override via variável de ambiente (útil para desenvolvimento local)
if (typeof process !== 'undefined' && process.env.REACT_APP_WP_API_URL) {
	apiBaseUrl = process.env.REACT_APP_WP_API_URL;
}

let axiosConfig = {
	development: {
		baseURL: apiBaseUrl || '/cms/index.php/wp-json',
		contentUrl: `${protocol}//${host}/cms/wp-content`,
		uploadsUrl: `https://sta-s3-${s3Env}.s3.amazonaws.com/cms/wp-content/uploads`,
		withCredentials: true
	},
	production: {
		baseURL: apiBaseUrl || '/cms/index.php/wp-json',
		contentUrl: `${protocol}//${host}/cms/wp-content`,
		uploadsUrl: `https://sta-s3-${s3Env}.s3.amazonaws.com/cms/wp-content/uploads`,
		withCredentials: true
	}
}

// Garante URLs válidas mesmo se env falhar (evita undefined//undefined)
if (!host || host === 'undefined' || !protocol || protocol === 'undefined') {
	host = 'dev.santillana.com.br';
	protocol = 'https:';
	s3Env = 'dev';
	apiBaseUrl = 'https://www.santillana.com.br/cms/index.php/wp-json';
	axiosConfig.development.contentUrl = `${protocol}//${host}/cms/wp-content`;
	axiosConfig.development.uploadsUrl = `https://sta-s3-${s3Env}.s3.amazonaws.com/cms/wp-content/uploads`;
	axiosConfig.production.contentUrl = `${protocol}//${host}/cms/wp-content`;
	axiosConfig.production.uploadsUrl = `https://sta-s3-${s3Env}.s3.amazonaws.com/cms/wp-content/uploads`;
}

export default axiosConfig[process.env.NODE_ENV];